import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/VisibeenLogo.png';
import './Header.css';

export default function Header() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 10);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <header className={`header ${scrolled ? 'scrolled' : ''}`} role="banner">
            <div className="header-container">
                <Link to="/" className="brand-link" aria-label="Visibeen Directory Home">
                    <img src={logo} alt="Visibeen Directory - Find Local Businesses in India" className="brand-logo" width="150" height="40" />

                </Link>

                <nav className="nav-links" role="navigation" aria-label="Main navigation">
                    <Link to="/" className="nav-link" aria-label="Go to homepage">Home</Link>
                    <a href="https://visibeen.com" className="nav-link" rel="noopener" aria-label="Visit Visibeen main website">Main Site</a>
                    <Link to="/" className="header-cta" aria-label="List your business on Visibeen Directory">List Your Business</Link>
                </nav>
            </div>
        </header>
    );
}
